<template>
	<div class="h-fit w-32 buttonPillCounterComponent">
		<div
			:id="id"
			class="flex flex-row h-10 bg-gray-100 rounded-full text-gray-500"
			:class="{ inputFieldError: hasError }">
			<button
				@click="decrement"
				class="rounded-l-full">
				<span class="m-auto text-xl">−</span>
			</button>
			<input
				v-model="count"
				@change="changed"
				aria-label="Increase item quantity"
				type="number"
				class="border-0 rounded-none" />
			<button
				@click="increment"
				class="rounded-r-full">
				<span class="m-auto text-xl">+</span>
			</button>
		</div>
		<label
			:for="id"
			v-if="hasError && errorMessage"
			class="inputFieldErrorLabel"
			>{{ errorMessage }}</label
		>
	</div>
</template>

<script setup>
	const { initialValue, max } = defineProps({
		id: {
			type: String,
			default: "inputField",
		},
		initialValue: {
			type: Number,
			default: 0,
		},
		max: {
			type: Number,
			default: 9999,
		},
	})

	const runtimeConfig = useRuntimeConfig()
	const count = ref(initialValue)
	const hasError = ref(false)
	const errorMessage = ref("")
	const emit = defineEmits(["changed"])

	const increment = () => {
		count.value++
		changed()
	}

	const decrement = () => {
		count.value--
		changed()
	}

	const changed = () => {
		let val = count.value
		hasError.value = false

		//Value cannot be less than 0
		if (val < 0 || val === "" || val === null) {
			count.value = 0
		}

		//Enforce max value
		if (val > max) {
			count.value = max
			hasError.value = true
			errorMessage.value = `Max: ${max}`
		}

		emit("changed", count.value)
	}
</script>

<style lang="scss" scoped>
	/* Hide the Arrow Buttons for input type number */

	/* Chrome, Safari, Edge, Opera */
	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	/* Firefox */
	input[type="number"] {
		-moz-appearance: textfield;
	}

	/* End Hide the Arrow Buttons */

	.buttonPillCounterComponent button {
		@apply hoverEffects w-20 cursor-pointer pb-1;
		@apply text-btn-pillCounter-text bg-btn-pillCounter-bg hover:text-btn-pillCounter-hoverText hover:bg-btn-pillCounter-hoverBg;
	}

	.buttonPillCounterComponent input,
	.buttonPillCounterComponent input:focus {
		@apply text-center w-full outline-none;
		@apply text-btn-pillCounter-text bg-btn-pillCounter-bg hover:text-btn-pillCounter-hoverText hover:bg-btn-pillCounter-hoverBg;
	}
</style>
